import React from "react";
import MonthlyTimeTable from "../MonthlyTimeTable";

const FebruarySehriIftaar = ({districtDetails}) => {
  return <MonthlyTimeTable month={2} title="February Sehri Iftar" columnKey="3Columns" districtDetails={districtDetails} />;
};

export default FebruarySehriIftaar;
